import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'ease-out', 'EaseOut', [["path",{"d":"M3 20s10 -16 18 -16","key":"svg-0"}]]);